import {Context, createContext, PropsWithChildren, useMemo} from 'react';

import {CatalogsContextType} from './catalogs-context-type';
import {useFilteredCatalogs} from './catalogs-hook';

export const CatalogsContext: Context<CatalogsContextType> = createContext<CatalogsContextType>({
    isLoading: true,
    catalogs: [],
});

type PropsType = PropsWithChildren<Record<string, unknown>>;

export function CatalogsContextProvider(props: PropsType): JSX.Element {
    const {children} = props;

    const {isInProgress, result: catalogs} = useFilteredCatalogs();

    const providerData: CatalogsContextType = useMemo(() => {
        return {
            isLoading: isInProgress,
            catalogs: catalogs || [],
        };
    }, [catalogs, isInProgress]);

    return <CatalogsContext.Provider value={providerData}>{children}</CatalogsContext.Provider>;
}
